/**
 * Clés localStorage à PRÉSERVER lors d'une déconnexion / reset de session.
 * Le device de la borne (eb-borne-device) et les préférences UI ne sont
 * pas des données de session utilisateur — ils ne doivent jamais être
 * effacés par un logout, une expiration ou une visite de /login.
 */
const PRESERVED_KEYS = [
    'eb-borne-device',      // credentials de la borne self-service (ApiKey)
    'eb-borne-theme',       // thème clair/sombre de la borne
    'eb-borne-accent',      // couleur d'accent de la borne
    'eb-borne-motifs',      // motifs de fond de la borne
    'eb-lsp-colors',        // palette LiveScreen
    'eb-lsp-mode',          // thème LiveScreen
    'eb_theme',             // thème applicatif
    'eb_sidebar_collapsed', // préférence sidebar
];

/** Efface la session sans toucher aux clés préservées (borne, préférences). */
export function clearSessionStorage() {
    const saved = PRESERVED_KEYS.map((k) => [k, localStorage.getItem(k)] as const);
    localStorage.clear();
    saved.forEach(([k, v]) => { if (v !== null) localStorage.setItem(k, v) });
}
